import { app } from '../../../../bootstrap/core';
import { cardHeaderComponent } from './cardHeader.component';

app.component('cardHeader', cardHeaderComponent);
